/**
 * Simple event hub
 */
class PubSub {
    constructor() {
        this.topics_ = new Map();
    }
    subscribe(topic, listener) {
        const listeners = this.topics_.get(topic) || [];
        const idx = listeners.push(listener) - 1;
        this.topics_.set(topic, listeners);
        return {
            remove: () => {
                delete listeners[idx];
            }
        };
    }
    publish(topic, data) {
        if (!this.topics_.has(topic)) {
            return;
        }
        const listeners = this.topics_.get(topic);
        listeners?.forEach(listener => {
            listener(data ? data : {});
        });
    }
    subscribeOnce(topic, listener) {
        const sub = this.subscribe(topic, (data) => {
            listener(data);
            sub.remove();
        });
    }
}
const pubSub = new PubSub();
export default pubSub;
